import { BaseService } from 'shared/services/BaseService';
import { IPurchaseOrderRow } from '../types';

class OrderLineService extends BaseService<IPurchaseOrderRow> {
  constructor() {
    super('purchordlines');
  }
}

export const orderLineService = new OrderLineService();
